import { render, staticRenderFns } from "./EmployeeVisaCreateOrUpdate.vue?vue&type=template&id=6f5f7650&"
import script from "./EmployeeVisaCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./EmployeeVisaCreateOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports